import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {GenericDocContainerModel} from "../../../../../../../models/aggregates/generic_doc";
import {BaseApiTemplateService, Core2Config} from "../../../shared";

@Injectable({providedIn: 'root'})
export class SupplierSalesDebitNoteService extends BaseApiTemplateService<GenericDocContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'supplier-sales-debit-notes';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'supplier-sales-debit-notes';
    this.httpClient = http;
  }

}
